export const STICKY_BAR_HEIGHT_VAR = "--ll-sticky-bar-height";
export const STICKY_BAR_TOP_INSET_VAR = "--ll-top-inset";
export const STICKY_BAR_OVERLAY_TOP_INSET_VAR = "--ll-overlay-top-inset";

export const STICKY_BAR_HEIGHT = `var(${STICKY_BAR_HEIGHT_VAR}, 0px)`;
export const STICKY_BAR_TOP_INSET = `var(${STICKY_BAR_TOP_INSET_VAR}, 0px)`;
export const STICKY_BAR_OVERLAY_TOP_INSET = `var(${STICKY_BAR_OVERLAY_TOP_INSET_VAR}, 0px)`;
export const STICKY_VIEWPORT_DEFAULT = "100dvh";
export const STICKY_BAR_TRANSITION_MS = 220;

export const STICKY_BAR_OVERLAY_POLICY = Object.freeze({
  rootOnly: "root-only",
  persistentOverlays: "persistent-overlays",
});

const normalizeSubtract = (subtract = "0px") => {
  if (subtract == null || subtract === "" || subtract === 0 || subtract === "0") {
    return "0px";
  }
  if (typeof subtract === "number") return `${subtract}px`;
  return String(subtract);
};

export const getStickyViewportHeight = ({
  overlay = false,
  subtract = "0px",
  viewport = STICKY_VIEWPORT_DEFAULT,
} = {}) => {
  const inset = overlay ? STICKY_BAR_OVERLAY_TOP_INSET : STICKY_BAR_TOP_INSET;
  const extra = normalizeSubtract(subtract);

  if (extra === "0px") {
    return `calc(${viewport} - ${inset})`;
  }

  return `calc(${viewport} - ${inset} - ${extra})`;
};

export const getStickyViewportSx = ({
  overlay = false,
  subtract = "0px",
  viewport = STICKY_VIEWPORT_DEFAULT,
  includeTop = false,
  includeMinHeight = false,
  sx = {},
} = {}) => {
  const inset = overlay ? STICKY_BAR_OVERLAY_TOP_INSET : STICKY_BAR_TOP_INSET;
  const height = getStickyViewportHeight({ overlay, subtract, viewport });

  return {
    ...(includeTop ? { top: inset } : {}),
    height,
    maxHeight: height,
    ...(includeMinHeight ? { minHeight: height } : {}),
    ...sx,
  };
};

export const getStickyOverlayMaxHeight = ({
  subtract = "0px",
  viewport = STICKY_VIEWPORT_DEFAULT,
} = {}) =>
  getStickyViewportHeight({
    overlay: true,
    subtract,
    viewport,
  });
